var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-components p-0 pl-1"},[_c('SegmentTitle',{attrs:{"segment":_vm.segment}})],1),(_vm.checkTitle)?_c('div',{staticClass:"title-components222 p-0 pl-1"},[_vm._v(" ※現在の支援より前の支援が完了していません。 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }